import { withTheme } from 'theme';
import material3 from 'theme/material3';

const getContainer = (clickable: boolean) => withTheme((theme) => ({
  paddingX: theme.spacing(2),
  paddingY: theme.spacing(1.5),
  background: clickable
    ? theme.palette.secondary.dark
    : theme.palette.secondary.light,
  borderRadius: material3.shape.medium,
  boxShadow: clickable ? material3.elevation.level1 : material3.elevation.level0,
  cursor: clickable ? 'pointer' : 'default',
  transition: 'background .18s ease, box-shadow .18s ease, transform .18s ease',
  '&:hover': clickable
    ? {
      boxShadow: material3.elevation.level2,
      transform: 'translateY(-1px)'
    }
    : undefined
}));

const getText = (clickable: boolean) => withTheme((theme) => ({
  fontWeight: '500',
  color: clickable
    ? theme.palette.text.secondary
    : theme.palette.text.primary
}));

const img = withTheme(() => ({
  width: '16px'
}));

const badge = withTheme(() => ({
  '& .MuiBadge-badge': {
    border: '2px solid #fff',
    background: '#FF9600',
    color: '#fff',
    minWidth: '24px',
    minHeight: '24px',
    borderRadius: '50%'
  }
}));

const styles = {
  getContainer,
  getText,
  img,
  badge
};

export default styles;
